// extracted by mini-css-extract-plugin
module.exports = {"regular":"regular_1psj1","semiBold":"semiBold_ekrau","bold":"bold_aq4mw","extraBold":"extraBold_7ot6s"};